module.exports = __webpack_public_path__ + "media/images/Virgin Islands-ac3ae31b.webp";